<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                {{ plant.serialNo }}
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Stat. Insp. Frequency:</strong><br />
                  {{ plant.statInspFrequency }} Months
                </p>
                <p>
                  <strong>Plant Type:</strong><br />
                  {{ plant.plantTypeName }}
                </p>
                <p>
                  <strong>Location:</strong><br />
                  {{ plant.location }}
                </p>
                <p>
                  <strong>Invoicing Name</strong><br />
                  {{ plant.invoicingName }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Contractor</strong><br />
                  {{ plant.contractorName }}
                </p>
                <p>
                  <strong>Contractor Region</strong><br />
                  {{ plant.contractorRegionName }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Client</strong><br />
                  <router-link :to="{ name: 'Client' }">
                    {{ plant.clientName }}
                  </router-link>
                </p>
                <p>
                  <strong>Site</strong><br />
                  <router-link :to="{ name: 'Site' }">
                    {{ plant.siteName }}
                  </router-link>
                </p>
                <p>
                  <strong>Building</strong><br />
                  <router-link :to="{ name: 'Building' }">
                    {{ plant.buildingName }}
                  </router-link>
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      plant: "portfolio/plant"
    })
  },
  async created() {
    await this.$store.dispatch(
      "portfolio/getPlant",
      this.$route.params.plantId
    );
  }
};
</script>

<style></style>
